import { render, staticRenderFns } from "./PaymentLinkFormPage.vue?vue&type=template&id=54b56c22&scoped=true&"
import script from "./PaymentLinkFormPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentLinkFormPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b56c22",
  null
  
)

export default component.exports